<template>
  <div class="flex flex-col">
    <div v-if="returns.length === 0" class="empty-state">
      <i class="mdi mdi-keyboard-return"></i>
      <p>This order does not have any return.</p>
    </div>
    <div v-else class="table-scroll">
      <table class="default-table">
        <thead>
          <tr>
            <th>RMA</th>
            <th>Date</th>
            <th>Status</th>
            <th>Shipping payer</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="returnData in returns" :key="returnData.id">
            <td>
              <button
                type="button"
                class="rma-link"
                @click="openReturn(returnData.id)"
              >
                {{ returnData.rma }}
                <i class="mdi mdi-open-in-new"></i>
              </button>
            </td>
            <td class="whitespace-nowrap">{{ returnData.date }}</td>
            <td>
              <span class="return-status">{{ returnData.status }}</span>
            </td>
            <td>{{ returnData.shippingPayer }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <ReturnModal
      :returnId="selectedReturnId"
      v-if="selectedReturnId"
      @close="selectedReturnId = null"
    ></ReturnModal>
  </div>
</template>
<script>
import ReturnModal from "@/components/order/ReturnModal.vue";
export default {
  props: {
    returns: {
      type: Array,
      required: true
    }
  },
  components: { ReturnModal },
  data() {
    return {
      selectedReturnId: null
    };
  },
  methods: {
    openReturn(id) {
      console.log(id);
      this.selectedReturnId = id;
      // let resolvedRoute = this.$router.resolve({
      //   name: "ReturnsPage"
      // });
      // window.open(`${resolvedRoute.href}?returnOpened=${id}`, "_blank");
    }
  }
};
</script>
<style lang="scss" scoped>
.table-scroll {
  overflow-x: auto;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 2rem 1rem;
  color: #6b7280;

  i {
    font-size: 2.25rem;
    color: #d1d5db;
  }

  p {
    margin: 0;
    font-size: 16px;
  }
}

.rma-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-weight: 600;
  color: #126e6a;

  i {
    font-size: 16px;
  }

  &:hover {
    text-decoration: underline;
  }
}

.return-status {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 999px;
  background: #f3f4f6;
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  white-space: nowrap;
}
</style>
